import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import {
	fetchMemberDetailsReportFailure,
	fetchMemberDetailsReportResponseResetChanged,
	fetchMemberDetailsReportSuccess,
} from './member-details-report.action';
import memberDetailsReportTypes from './member-details-report.type';
import { postAllMemberDetailReport } from './member-details-report.service';

/** ***************** FETCH MEMBER DETAILS REPORT START *********************** */
export function* fetchMemberDetailsReportReportDetails({ payload }: any) {
	try {
		const {
			companyID,
			databaseName,
			fromDate,
			isThrift,
			limit,
			toDate,
			tillDate,
			userLevel,
			loanFunder,
			loanFilter,
			loanDateFilter,
			selectbranch,
			userID,
			dateFilter,
			loanStatusFilter,
			wiseFilter,
		} = payload;
		const key = 'PostAllMemberDetailReportKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			TillDate: tillDate,
			UserLevel: userLevel,
			SearchByLoanModal: loanFilter,
			SearchBy: loanDateFilter,
			BranchID: selectbranch,
			UserID: userID,
			SearchType: dateFilter,
			LoanStatus: loanStatusFilter,
			OrderListBy: wiseFilter,
			LoanFunder: loanFunder,
			Limit: limit,
			IsThriftExist: isThrift,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(postAllMemberDetailReport, encodeData);
		if (responseData.data.statusCode === '101') {
			yield put(fetchMemberDetailsReportFailure(responseData.data));
		} else {
			yield put(fetchMemberDetailsReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchMemberDetailsReportFailure(error));
	}
}

export function* resetFetchMemberDetailsReportResponse() {
	yield put(fetchMemberDetailsReportResponseResetChanged());
}

export function* onFetchMemberDetailsReportDetails() {
	yield takeLatest(
		memberDetailsReportTypes.FETCH_MEMBER_DETAILS_REPORT_START,
		fetchMemberDetailsReportReportDetails,
	);
}

export function* onFetchMemberDetailsReportResponseReset() {
	yield takeLatest(
		memberDetailsReportTypes.FETCH_MEMBER_DETAILS_REPORT_RESPONSE_RESET_START,
		resetFetchMemberDetailsReportResponse,
	);
}
/** ********************* FETCH MEMBER DETAILS REPORT END ******************** */

export function* memberDetailsReportSaga() {
	yield all([
		call(onFetchMemberDetailsReportDetails),
		call(onFetchMemberDetailsReportResponseReset),
	]);
}
